import { Tutor, calendarFor } from '../data/tutors';

/**
 * Calendly + smooth-scroll helpers shared across components.
 */

const openCalendlyUrl = (url: string): void => {
  if (window.Calendly) {
    window.Calendly.initPopupWidget({ url });
  } else {
    window.open(url, '_blank', 'noopener');
  }
};

/**
 * Open a tutor's booking calendar. Tutors with their own Calendly link
 * (TUTOR_CALENDARS) book directly; otherwise the shared calendar is
 * tagged with the tutor's initials so the session lands with the right
 * person.
 */
export const openTutorCalendly = (tutor: Tutor): void => {
  const { url, shared } = calendarFor(tutor);
  if (!shared) {
    openCalendlyUrl(url);
    return;
  }
  const joiner = url.includes('?') ? '&' : '?';
  openCalendlyUrl(`${url}${joiner}a1=${encodeURIComponent(`Tutor ${tutor.initials}`)}`);
};

const PREFERRED_TUTOR_KEY = 'bb-preferred-tutor';

/**
 * Remember which tutor's calendar the visitor last browsed before
 * paying, so the booking page can bring them straight back to confirm.
 */
export const rememberPreferredTutor = (tutorId: string): void => {
  try {
    window.localStorage.setItem(PREFERRED_TUTOR_KEY, tutorId);
  } catch {
    /* storage unavailable; the roster still works without the shortcut */
  }
};

export const getPreferredTutorId = (): string | null => {
  try {
    return window.localStorage.getItem(PREFERRED_TUTOR_KEY);
  } catch {
    return null;
  }
};

/** Smooth-scroll to a section by element id. */
export const scrollToId = (id: string): void => {
  const element = document.getElementById(id);
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' });
  }
};
